const sectionsNavLinks = document.querySelectorAll('.sectionsNavTrigger')

if (sectionsNavLinks) {
	sectionsNavLinks.forEach((item) => {
		item.addEventListener('click', () => {
			let section = item.dataset.section;
			let targetedSection = document.getElementById(section);

			targetedSection.scrollIntoView({
				behavior: "smooth",
				block: "start",
				inline: "nearest"
			})
		})
	})
}
